/**
 * Decode access token and return an object
 * @param token 
 * @returns 
 */
export const parseToken = (token: string) => {
  try {
    const tokenObj = JSON.parse(atob(token.split('.')[1]));
    return tokenObj;
  } catch (e) {
    return null;
  }
}

/**
 * Check if a token is expired
 * @param token JWT token
 * @returns boolean indicating if token is expired
 */
export const isTokenExpired = (token: string): boolean => {
  try {
    const tokenObj = parseToken(token);
    if (!tokenObj || !tokenObj.exp) return true;
    
    const currentTime = Math.floor(Date.now() / 1000);
    return tokenObj.exp < currentTime;
  } catch (e) {
    return true;
  }
}

/**
 * Get token expiration time in seconds from now
 * @param token JWT token
 * @returns seconds until expiration, or 0 if expired/invalid
 */
export const getTokenExpirationTime = (token: string): number => {
  try {
    const tokenObj = parseToken(token);
    if (!tokenObj || !tokenObj.exp) return 0;
    
    const currentTime = Math.floor(Date.now() / 1000);
    const expirationTime = tokenObj.exp - currentTime;
    return Math.max(0, expirationTime);
  } catch (e) {
    return 0;
  }
}

/**
 * Takes an access token and return true if the user has the permission for the given client
 * @param resource Keycloak client to check for permission
 * @param permission name of the client permission
 * @param token the access token
 * @returns 
 */
export const hasResourceRole = (resource: string, permission: string, token: string): boolean => {
  const tokenObj = parseToken(token);
  const resourceAccess = tokenObj?.resource_access;
  if (!resourceAccess) return false;
  const roles = resourceAccess[resource || '']?.roles || [];
  return roles.indexOf(permission) !== -1;
}